import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const cancelSubscription = (
  accountId: number,
  cancelReason: string,
  cancelDetail: string,
  reachOutDate?: string,
) =>
  createGenericDispatcher({
    name: 'CANCEL_SUBSCRIPTION',
    loadFunction: () =>
      Api.post(`/account/${accountId}/cancel-subscription`, {
        body: JSON.stringify({
          cancelReason,
          cancelDetail,
          reachOutDate,
        }),
      }),
    args: {
      accountId,
      cancelReason,
      cancelDetail,
      reachOutDate,
    },
  });
